// Unpublished Work © 2023-2024 Deere & Company.
export const PROMOTION_PARTS_DETAIL_DOWNLOAD =
  "Promotion Part Details Download";
export const INVOICE_CONSOLIDATION = "Invoice Consolidation";
export const ALL_ORDERS_DOWNLOAD = "All Orders Download";
export const INVOICE_EXCEL = "Invoices";
export const RETURNS_EXCEL = "Returns";
export const RETURN_SUMMARY_EXCEL = "Return Summary";
export const INVOICE_FILTER = "Invoices by Filter";
export const INVOICE_BY_ACCOUNT_NUMBERS_CONSOLIDATION =
  "Invoices by Account with Numbers";
export const INVOICE_BY_ACCOUNT_FILTER_CONSOLIDATION =
  "Invoices by Account with Filter";
export const MEXICO_DEALER_LOCATION = "MX";
export const US_DEALER_LOCATION = "US";
export const UK_DEALER_LOCATION = "GB";
export const CHINA_DEALER_LOCATION = "CN";
export const CANADA_DEALER_LOCATION = "CA";
export const INDIA_DEALER_LOCATION = "IN";
export const BRAZIL_DEALER_LOCATION = "BR";
export const ARGENTINA_DEALER_LOCATION = "AR";
export const INDIA_GST_ANNEXURE_INVOICE = "ZGAX";
export const INDIA_GST_TRADE_INVOICE = "ZGRD";
export const BRAZIL_NFE_ATTACHMENT = "ZN55";
export const CANADA_INVOICE_PDF_ATTACHMENT = "ZCIV";
export const BRAZIL_EXPORT_MRUS = ["2L00", "4M00", "2800"];
export const ALL_ACCOUNTS = "ALL_ACCOUNTS";
export const ORDERS_BY_LINE_ITEM_DOWNLOAD = "Orders by Line Item Download";
export const ARGENTINA_INVOICE_PDF = "ZRSO";

export const NOTIFICATIONS_TYPE_TO_DELETE = [
  "", // Added this for the promotion notifications which are were created before this change, because before this they didn't have a type
  PROMOTION_PARTS_DETAIL_DOWNLOAD,
  ALL_ORDERS_DOWNLOAD,
  ORDERS_BY_LINE_ITEM_DOWNLOAD,
];

export const ALL_NOTIFICATIONS = [
  PROMOTION_PARTS_DETAIL_DOWNLOAD,
  ALL_ORDERS_DOWNLOAD,
  ORDERS_BY_LINE_ITEM_DOWNLOAD,
  INVOICE_EXCEL,
  INVOICE_FILTER,
  INVOICE_BY_ACCOUNT_NUMBERS_CONSOLIDATION,
  INVOICE_BY_ACCOUNT_FILTER_CONSOLIDATION,
  INVOICE_CONSOLIDATION,
  "Invoice",
  RETURNS_EXCEL,
  RETURN_SUMMARY_EXCEL,
];
